import PageTitle from '../../components/PageTitle'
import EngineTab from './EngineTab'

/**
 * PACE → Allocations. Lists PACE allocation records (live + shadow) with the ranked-courier
 * explainer, filters and stats. The per-merchant PACE live + shadow-compare controls now
 * live on the Merchant List page; here the merchant's current state is shown read-only.
 * Internal/Tools only.
 */
export default function ShadowRunPage() {
  return (
    <div>
      <PageTitle>PACE · Allocations</PageTitle>
      <EngineTab />
    </div>
  )
}
